import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Container,
  Alert,
  Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  getDateToString
} from 'src/utils/date';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { OBJECT_TYPES, RESOLUTION, USER_ROLES } from 'src/constants';
import SummaryChart from './SummaryChart';
import ColdWaterConsumption from './Components/ColdWaterConsumption';
import HotWaterConsumption from './Components/HotWaterConsumption';
import ElectricityConsumption from './Components/ElectricityConsumption';
import HeatenergyConsumption from './Components/HeatenergyConsumption';
import EVChargingConsumption from './Components/EVChargingConsumption';
import 'moment/locale/sv';
import SummaryTable from './SummaryTable';
import DelayedSpinner from 'src/components/DelayedSpinner';
import { useMemo } from 'react';
import authService from 'src/services/authService';
import DateScrubber from 'src/components/DateScrubber';
import StatisticsButton from 'src/components/StatisticsButton';
import { useSelector } from 'react-redux';
import ConsumptionTable from './Components/ConsumptionTable';
import { EnergyNumberFormatString, VolumeNumberFormatString } from 'src/utils/numbers';
import { useConsumption } from './Components/ConsumptionContext';
import DashboardCard from 'src/views/dashboards/DashboardCard';
import DashboardCardTitle from 'src/views/dashboards/DashboardCardTitle';
import { convertJsonToHtml } from 'src/utils/convertJsonToHtml';
import AverageComparisonCard from './AverageComparisonCard';
import LastMonthComparisonCard from './LastMonthComparisonCard';
import ConsumptionAlertsCard from './ConsumptionAlertsCard';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  table: {
    border: 'none'
  },
  tablecell: {
    border: 'none',
    padding: '0px'
  },
  header: {
    display: 'flex'
  },
  [theme.breakpoints.down('sm')]: {
    header: {
      flexDirection: 'column'
    }
  },
  container: {
    marginTop: theme.spacing(2)
  },
  description: {
    fontSize: '1rem',
  },
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ApartmentSummaryTab({ apartment, className, ...rest }) {
  const classes = useStyles();
  const { denotation } = useParams();
  //const [consumption, setConsumption] = useState(null);
  const consumption = useConsumption();
  const [tableData, setTableData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const { user } = useSelector(state => state.account);

  const query = useQuery();
  const queryFromdate = query.get('from');
  const queryTodate = query.get('to');
  const queryResolution = Number(query.get('res'));

  const path = '/workers/worker.js';
  const temperatureWorker = useMemo(() => new Worker(path), [path]);

  /*useEffect(() => {
    temperatureWorker.onmessage = ({ data }) => {
      const [consumptionData, tableData] = data.map(d => JSON.parse(d));
      setConsumption(consumptionData);
      setTableData(tableData);
      setIsFetching(false);
    };

    return () => temperatureWorker.terminate();
  }, [temperatureWorker]);

  const fetch = useCallback(() => {
    if (queryFromdate && queryTodate) {
      const type = OBJECT_TYPES.APARTMENT;
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const url = `${baseUrl}/api/metering/customerconsumption/forcustomer/${denotation}/${queryFromdate}/${queryTodate}`;
      const tableUrl = `${baseUrl}/api/metering/customerconsumption/apartmentreadings/forcustomer/${denotation}/${queryFromdate}/${queryTodate}/0`;

      temperatureWorker.postMessage({
        message: 'multi-fetch',
        payload: { urls: [url, tableUrl], token: authService.getAccessToken() }
      });
      setIsFetching(true);
    }
  }, [queryFromdate, queryTodate]);

  useEffect(() => {
    fetch();
  }, [fetch]);
  useEffect(() => {
    console.log(consumption);
  }, [consumption]);*/

  // console.log(tableData);

  return (
    <Container maxWidth={false} className={classes.container}>
      <Box flexGrow={1}>
        <Grid container spacing={3}>
          <Grid item lg={12} xl={12} xs={12}>
            {/*{user.usertype === USER_ROLES.SUPERADMIN &&
              <StatisticsButton
                id={apartment.id}
                type={OBJECT_TYPES.APARTMENT}
                fromDate={queryFromdate}
                toDate={queryTodate}
              />
            }*/}
            <Box className={classes.header}>
              {consumption && isFetching &&
                <Box display="flex" flexGrow={1}>
                  <DelayedSpinner size={50} delay={500} justifyContent="flex-end" />
                </Box>
              }
            </Box>
          </Grid>
          {consumption ? (
            <>
              <Grid item lg={12} xl={6} xs={12}>
                <SummaryTable consumption={consumption} lastMonthData={consumption.lastPeriodSummary} res={queryResolution} />
                {consumption.alerts && 
                <ConsumptionAlertsCard alerts={consumption.alerts}/>
                }
                {consumption.averageMetering !== null &&
                <AverageComparisonCard consumption={consumption} averageData={consumption.averageMetering} top20Data={consumption.top20PercentSummary} sx={{mt: 2}} />
                }
                {/*(consumption.lastPeriodSummary !== null && queryResolution === 1) &&
                <LastMonthComparisonCard consumption={consumption} lastMonthData={consumption.lastPeriodSummary} sx={{mt: 2}} />
                */}
                {(consumption?.longShownMessage && consumption?.longShownMessage !== "" && convertJsonToHtml(JSON.parse(consumption?.longShownMessage)) !== "") &&
                <DashboardCard sx={{mt: 2}}>
                    <DashboardCardTitle title="Meddelande" />
                    <Typography
                        variant="body2"
                        className={classes.description}
                        component="div"
                        dangerouslySetInnerHTML={{ __html: convertJsonToHtml(JSON.parse(consumption?.longShownMessage)) }}
                    />
                </DashboardCard>
                }
              </Grid>

              <Grid item lg={12} xl={6} xs={12}>
                <SummaryChart consumption={consumption} />
              </Grid>

              {/*consumption?.coldWaterSensorsExists && (
                <Grid item lg={12} xl={6} xs={12}>
                  <ColdWaterConsumption consumption={consumption} />
                  <ConsumptionTable
                    title="Kallvattenförbrukning"
                    consumption={consumption}
                    volumeFormatter={VolumeNumberFormatString}
                    fieldName="coldwater"
                  />
                </Grid>
              )*/}
              {/*consumption?.hotWaterSensorsExists && (
                <Grid item lg={12} xl={6} xs={12}>
                  <HotWaterConsumption consumption={consumption} />
                  <ConsumptionTable
                    title="Varmvattenförbrukning"
                    consumption={consumption}
                    volumeFormatter={VolumeNumberFormatString}
                    fieldName="hotwater"
                  />
                </Grid>
              )*/}
              {/*consumption?.electicitySensorsExists && (
                <Grid item lg={12} xl={6} xs={12}>
                  <ElectricityConsumption consumption={consumption} />
                  <ConsumptionTable
                    title="Elförbrukning"
                    consumption={consumption}
                    volumeFormatter={EnergyNumberFormatString}
                    fieldName="electricity"
                  />
                </Grid>
              )*/}
              {/*consumption?.heatEnergySensorsExists && (
                <Grid item lg={12} xl={6} xs={12}>
                  <HeatenergyConsumption consumption={consumption} />
                  <ConsumptionTable
                    title="Värmeenergiförbrukning"
                    consumption={consumption}
                    volumeFormatter={EnergyNumberFormatString}
                    fieldName="heatenergy"
                  />
                </Grid>
              )*/}
              {/*consumption?.evChargingSensorsExists && (
                <Grid item lg={12} xl={6} xs={12}>
                  <EVChargingConsumption consumption={consumption} />
                  <ConsumptionTable
                    title="Elbilsladdning"
                    consumption={consumption}
                    volumeFormatter={EnergyNumberFormatString}
                    fieldName="evCharging"
                  />
                </Grid>
              )*/}
            </>
          ) : (
            <DelayedSpinner size={55} />
          )}
        </Grid>
      </Box>
    </Container>
  );
}

ApartmentSummaryTab.propTypes = {
  className: PropTypes.string,
  apartment: PropTypes.object.isRequired
};

export default ApartmentSummaryTab;
